import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TenantMenuItem from './TenantMenuItem';

class AuthDropdown extends Component {
  constructor(props) {
    super(props);

    this.setMenuRef = this.setMenuRef.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.state = {};
  }

  setMenuRef(ref) {
    this.menuRef = ref;
  }

  closeMenu(e) {
    this.setState({ mainMenu: false, tenantMenu: false });
    document.removeEventListener('click', this.handleDocumentClick, false);
  }

  handleDocumentClick(e) {
    if (!this.menuRef.contains(e.target) || e.target.dataset.menuToggle) {
      this.closeMenu();
    }
  }

  toggleMenu(open, menuName) {
    return (e) => {
      const state = {};
      e.preventDefault();

      if (menuName === 'mainMenu') {
        if (open) {
          document.addEventListener('click', this.handleDocumentClick, false);
        } else {
          document.removeEventListener('click', this.handleDocumentClick, false);
        }
      }

      state[menuName] = open;
      this.setState(state);
    };
  }

  render() {
    const { picture, tenant, tenants, userName, manageUrl } = this.props;
    const { mainMenu, tenantMenu } = this.state;

    return (
      <li ref={this.setMenuRef} className={`dropdown tenant-dropdown ${mainMenu ? 'open' : ''}`}>
        <span
          onClick={this.toggleMenu(!mainMenu, 'mainMenu')}
          tabIndex={0}
          role="button"
          className="btn-dro btn-username"
        >
          {tenant && (
            <span className="username-text truncate" title={tenant.name}>
              {tenant.name}
            </span>
          )}
          <img src={picture} alt="avatar" className="picture avatar" />
          <i className="icon-budicon-460" />
        </span>
        <div
          className={`tenant-menu-container dropdown-menu animated ${
            tenantMenu ? 'switch-tenant' : ''
          }`}
        >
          <div className="tenant-menu-slide">
            <ul className="tenant-menu">
              {tenant && (
                <li className="tenant-menu-header">
                  <a>
                    <h5>{tenant.name}</h5>
                    <span>
                      {tenant.region} - {tenant.subscription.name}
                    </span>
                  </a>
                </li>
              )}
              <li className="tenant-menu-item">
                <a href={manageUrl} tabIndex={0} role="menuitem" data-menu-toggle>
                  <i className="tenant-menu-icon icon-budicon-394" />
                  <span className="icon-text">Open Dashboard</span>
                </a>
              </li>
              {tenants.length > 0 && (
                <li className="tenant-menu-item">
                  <a
                    onClick={this.toggleMenu(!tenantMenu, 'tenantMenu')}
                    tabIndex={0}
                    role="menuitem"
                    className="tenant-switch-btn"
                  >
                    <i className="tenant-menu-icon icon-budicon-436" />
                    <span className="icon-text">Switch tenant</span>
                  </a>
                </li>
              )}
              <li className="divider" />
              <li>
                <div className="user-header clearfix">
                  <div className="col-xs-4">
                    <img alt="profile" className="picture" src={picture} />
                  </div>
                  <div className="col-xs-8 profile-info">
                    <h5 className="user-name truncate">{userName}</h5>
                    <a href={`${manageUrl}/#/profile`} data-menu-toggle>
                      View profile
                    </a>
                  </div>
                </div>
              </li>
              <li className="divider" />
              <li className="tenant-menu-item">
                <a href="/docs/auth/logout" data-menu-toggle>
                  <i className="tenant-menu-icon icon-budicon-519" />
                  <span className="icon-text">Logout</span>
                </a>
              </li>
            </ul>

            <ul id="tenant-selector-pane" className="tenant-menu">
              <a
                onClick={this.toggleMenu(!tenantMenu, 'tenantMenu')}
                role="menuitem"
                tabIndex={0}
                className="tenant-selector-back-arrow tenant-switch-btn"
              >
                <i className="icon-budicon-521" />
              </a>
              <li className="tenant-selector-header">
                <h5>Switch tenant</h5>
              </li>
              <ul className="tenant-selector-inner tenant-menu">
                {tenants.map(t => (
                  <TenantMenuItem
                    data-menu-toggle
                    key={t.url}
                    {...t}
                    selected={tenant.name === t.name && tenant.region === t.region}
                  />
                ))}
              </ul>
            </ul>
          </div>
        </div>
      </li>
    );
  }
}

AuthDropdown.propTypes = {
  picture: PropTypes.string.isRequired,
  manageUrl: PropTypes.string.isRequired,
  tenant: PropTypes.object.isRequired,
  tenants: PropTypes.array.isRequired,
  userName: PropTypes.string.isRequired
};

AuthDropdown.defaultProps = {
  picture: '',
  manageUrl: 'https://manage.auth0.com',
  tenants: [],
  userName: ''
};

export default AuthDropdown;
